import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionItemProps,
  AccordionPanel,
  Box,
  Stack,
  StackProps
} from '@chakra-ui/react'
import { LandingContainer } from 'components/common/LandingContainer'
import { AccordionSectionData } from 'components/sections/AccordionSection'
import NewChevronDown from 'components/svg/NewChevronDown'
import NewChevronRight from 'components/svg/NewChevronRight'
import { Body1, H2, H3 } from 'components/typography'
import { FC } from 'react'

interface AccordionNewSectionProps extends StackProps {
  categoryTitle?: string
  sections: AccordionSectionData
  id?: string
  itemColor?: string
  bgColor?: string
  textColor?: string
  disablePadding?: boolean
  accordionItemProps?: AccordionItemProps
}

const AccordionNewSection: FC<AccordionNewSectionProps> = ({
  categoryTitle = 'Perguntas frequentes',
  sections,
  id,
  bgColor,
  itemColor,
  textColor,
  disablePadding = false,
  accordionItemProps,
  ...rest
}) => {
  return (
    <Box bg={bgColor || 'alabaster'}>
      <LandingContainer
        position="relative"
        px={disablePadding ? 0 : 6}
        py={disablePadding ? 0 : { base: 8, lg: 32 }}
        gap={{ base: '1.5rem', lg: '3rem' }}
        color={textColor || 'phthalo'}
        {...rest}
      >
        <Box {...{ id }} position="absolute" top="-40px" />
        {categoryTitle && <H2 textAlign={{ base: 'center', lg: 'left' }}>{categoryTitle}</H2>}
        <Accordion allowToggle>
          {sections.map(({ title, body }, index, array) => {
            const isLast = index === array.length - 1

            return (
              <AccordionItem
                key={title}
                border="none"
                rounded="24px"
                mb={isLast ? 0 : 3}
                bg={itemColor || 'grayscale.20'}
                {...accordionItemProps}
              >
                {({ isExpanded }) => (
                  <>
                    <AccordionButton alignItems="flex-start" rounded="24px" p={6}>
                      <H3
                        flex={1}
                        textAlign="left"
                        fontWeight={800}
                        fontSize={{ base: '1rem', lg: '1.5rem' }}
                        letterSpacing={{ base: '-0.01em', lg: '-0.03em' }}
                        lineHeight={{ base: '1.25rem', lg: '1.75rem' }}
                      >
                        {title}
                      </H3>
                      <Box pl={4}>
                        {isExpanded ? (
                          <NewChevronDown width="16px" fill="phthalo" />
                        ) : (
                          <NewChevronRight height="16px" fill="phthalo" />
                        )}
                      </Box>
                    </AccordionButton>
                    <AccordionPanel color={textColor || 'phthalo'} p={6}>
                      <Stack spacing="3.5">{typeof body === 'string' ? <Body1>{body}</Body1> : <>{body}</>}</Stack>
                    </AccordionPanel>
                  </>
                )}
              </AccordionItem>
            )
          })}
        </Accordion>
      </LandingContainer>
    </Box>
  )
}

export default AccordionNewSection
